import { Link, useLocation } from "react-router-dom";

const HIDE_ON = ["/admin", "/checkout", "/payment", "/order-success", "/verify-email", "/forgot-password", "/reset-password"];

export default function Footer() {
  const { pathname } = useLocation();
  if (HIDE_ON.some((p) => pathname === p || pathname.startsWith("/admin"))) return null;

  return (
    <footer className="tc-footer">
      <div className="tc-footer-inner">

        {/* Brand */}
        <div className="tc-footer-brand">
          <Link to="/" className="tc-footer-logo">
            <picture>
              <source srcSet="/logo.webp" type="image/webp" />
              <img src="/logo.png" alt="Tablecure" className="tc-footer-logo-img" loading="lazy" />
            </picture>
          </Link>
          <p className="tc-footer-tagline">
            Precision lighting engineered for people who create.
          </p>
        </div>

        {/* Links */}
        <div className="tc-footer-cols">
          <div className="tc-footer-col">
            <div className="tc-footer-col-title">Shop</div>
            <Link to="/" className="tc-footer-link">All Products</Link>
            <Link to="/" className="tc-footer-link">Desk Lamps</Link>
          </div>
          <div className="tc-footer-col">
            <div className="tc-footer-col-title">Support</div>
            <Link to="/contact" className="tc-footer-link">Contact Us</Link>
            <Link to="/shipping-policy" className="tc-footer-link">Shipping &amp; Returns</Link>
            <Link to="/dashboard" className="tc-footer-link">My Account</Link>
          </div>
          <div className="tc-footer-col">
            <div className="tc-footer-col-title">Legal</div>
            <Link to="/privacy-policy" className="tc-footer-link">Privacy Policy</Link>
            <Link to="/terms" className="tc-footer-link">Terms of Service</Link>
            <Link to="/shipping-policy" className="tc-footer-link">Returns Policy</Link>
          </div>
        </div>

      </div>

      <div className="tc-footer-bottom">
        <span className="tc-footer-copy">
          &copy; {new Date().getFullYear()} Tablecure. All rights reserved.
        </span>
        <div className="tc-footer-bottom-links">
          <Link to="/privacy-policy" className="tc-footer-bottom-link">Privacy</Link>
          <span className="tc-footer-bottom-sep" />
          <Link to="/terms" className="tc-footer-bottom-link">Terms</Link>
          <span className="tc-footer-bottom-sep" />
          <Link to="/contact" className="tc-footer-bottom-link">Contact</Link>
        </div>
      </div>
    </footer>
  );
}
